/**
 * @module app.cm
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getCaseManagementQuestionTypes(): DynamicViews {
    return {
        'CM.Goal':
            [{ title: 'Suggest Goal', url: PLATFORM.moduleName('app/cm/components/assessments/questions/question-suggest-goal') }],
        'CM.SystemReview':
            [{ title: 'System Review', url: PLATFORM.moduleName('app/cm/components/assessments/questions/question-system-review') }]
    };
}
